import * as React from 'react';
import Svg, {Path, Rect, G, SvgProps} from 'react-native-svg';

type Props = Omit<SvgProps, 'width' | 'height'> & {
  width?: number;
  height?: number;
  bgFill?: string; // background fill inside the SVG
  bgStroke?: string; // background stroke
  bgOpacity?: number; // background opacity
  bgRadius?: number; // background corner radius
  offsetX?: number; // nudge art horizontally
  offsetY?: number; // nudge art vertically
};

const AramarkMenuItemBoilerPlate = ({
  width = 110,
  height = 110,
  bgFill = '#111111',
  bgStroke = '#CFCFCF',
  bgOpacity = 0.95,
  bgRadius = 7.5,
  offsetX = 20.5,
  offsetY = 22,
  ...rest
}: Props) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 110 110"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    {...rest}
  >
    <Rect
      opacity={bgOpacity}
      x={0.5}
      y={0.5}
      width={109}
      height={109}
      rx={bgRadius}
      fill={bgFill}
      stroke={bgStroke}
    />
    <G transform={`translate(${offsetX} ${offsetY})`}>
      <Path
        d="M13.3909 28.2864C13.486 27.6601 13.0375 27.2185 11.9911 27.0563L9.8846 26.7319L9.57202 28.7324L11.7736 29.0749C12.6797 29.2145 13.2867 28.9577 13.3909 28.2909M13.4498 25.1505C13.5404 24.5557 13.1191 24.1412 12.2674 24.006L10.3557 23.7132L10.0522 25.6506L11.8642 25.9299C12.7159 26.0606 13.3411 25.8263 13.4453 25.1505M14.8133 25.146C14.6729 26.0426 14.084 26.421 13.477 26.6148C14.315 27.0428 14.8541 27.6286 14.7001 28.6288C14.4962 29.9399 13.2731 30.4671 11.5924 30.2058L8.09521 29.6651L9.23227 22.375L12.6208 22.8977C14.1429 23.1319 14.99 24.0015 14.8133 25.146Z"
        fill="white"
      />
      <Path
        d="M21.4274 25.4528L19.4975 25.1555L19.117 27.602L21.0604 27.9039C22.0117 28.0481 22.6867 27.6651 22.8045 26.9172C22.9313 26.1152 22.4104 25.6105 21.4319 25.4573M22.057 31.8238L20.5983 28.9943L18.9358 28.7374L18.5372 31.2786L17.2098 31.0713L18.3469 23.7812L21.7127 24.2994C23.4523 24.5697 24.381 25.6195 24.159 27.0433C23.9687 28.2508 23.1125 28.8636 22.0117 28.9852L23.6199 32.0581L22.057 31.8148V31.8238Z"
        fill="white"
      />
      <Path
        d="M33.6088 27.3122L29.3369 26.6544L29.0379 28.5468L32.8296 29.1325L32.6484 30.2769L28.8612 29.6912L28.5532 31.6512L32.8839 32.318L32.7027 33.4669L27.0492 32.5928L28.1862 25.3027L33.79 26.1678L33.6088 27.3122Z"
        fill="white"
      />
      <Path
        d="M40.49 28.7197L38.7413 31.4366L41.3416 31.8376L40.49 28.7197ZM43.5432 35.1402L42.1389 34.9239L41.6451 33.0451L38.0709 32.4954L37.0199 34.1354L35.6609 33.9237L40.1321 27.0977L41.3643 27.2869L43.5432 35.1402Z"
        fill="white"
      />
      <Path
        d="M53.5637 36.6891L51.9556 36.4413L49.8898 32.7602L48.5308 33.7469L48.2001 35.86L46.8728 35.6528L48.0099 28.3672L49.3372 28.5699L48.7664 32.2375L52.9341 29.1241L54.5604 29.3764L50.9318 32.0258L53.5637 36.6891Z"
        fill="white"
      />
      <Path
        d="M60.2004 33.3823C61.7406 34.0041 62.4835 34.6845 62.2933 35.901C62.0804 37.2752 60.8391 37.915 59.2536 37.6717C58.0984 37.4915 57.0701 36.9418 56.2819 36.0181L57.2241 35.2251C57.8538 35.9415 58.5243 36.3966 59.462 36.5408C60.2819 36.6669 60.8572 36.3831 60.9433 35.8199C61.0249 35.2882 60.7666 34.9593 59.4121 34.4321C57.8629 33.8104 57.0293 33.2111 57.2377 31.8549C57.437 30.5843 58.6466 29.895 60.1506 30.1293C61.2514 30.3005 62.0758 30.7556 62.7508 31.4674L61.8856 32.328C61.2831 31.7333 60.6443 31.3683 59.9512 31.2602C59.1721 31.1385 58.6602 31.4539 58.5831 31.945C58.4925 32.5173 58.8006 32.8191 60.1959 33.3778"
        fill="white"
      />
      <Path
        d="M25.8351 50.1066C25.9031 50.1517 25.9846 50.1742 26.0617 50.1697C26.1885 50.1697 26.3153 50.1021 26.3923 49.985L31.2758 42.5102L30.406 42.375L25.7219 49.5479C25.5996 49.7327 25.6539 49.9805 25.8397 50.1021"
        fill="white"
      />
      <Path
        d="M53.2422 19.8289C52.3452 18.6079 51.3441 17.495 50.2523 16.4902L49.8083 17.1661C52.8843 20.0362 55.1221 23.7353 56.2003 27.8354L57.0565 27.9661C56.3453 25.0689 55.0587 22.307 53.2331 19.8244"
        fill="white"
      />
      <Path
        d="M30.9405 56.2713C32.141 56.456 33.3369 56.5461 34.5147 56.5461C42.4514 56.5461 49.7222 52.473 53.9352 46.0705L53.0836 45.9354C48.3632 52.8605 39.901 56.866 31.0583 55.5008C22.1702 54.1266 15.3117 47.7106 12.956 39.641L12.1044 39.5059C14.4464 48.0215 21.613 54.8295 30.936 56.2668"
        fill="white"
      />
      <Path
        d="M47.1446 14.0796C44.4311 12.3269 41.3597 11.1464 38.0663 10.6373C28.5395 9.16393 19.4431 13.7101 14.6956 21.4192L15.5382 21.5499C19.579 15.197 26.7048 11.1419 34.492 11.1419C35.6336 11.1419 36.7888 11.2275 37.9485 11.4077C41.1785 11.9079 44.1366 13.0748 46.7142 14.7464L47.1491 14.0796H47.1446Z"
        fill="white"
      />
      <Path
        d="M51.5342 14.5299L51.1039 15.1922C52.3406 16.3096 53.4776 17.5577 54.4833 18.9274C56.5581 21.7479 57.967 24.9063 58.6918 28.218L59.5208 28.3441C58.796 24.8162 57.3146 21.455 55.113 18.4633C54.0484 17.0125 52.8434 15.7014 51.5342 14.5254"
        fill="white"
      />
      <Path
        d="M55.6114 46.3313C53.9489 49.0302 51.7563 51.4046 49.1108 53.324C43.7743 57.2034 37.2329 58.7848 30.705 57.7756C20.5259 56.2031 12.7523 48.6292 10.451 39.2439L9.61743 39.1133C11.8915 48.94 19.9687 56.906 30.5827 58.546C31.91 58.7488 33.2373 58.8524 34.5556 58.8524C39.9283 58.8524 45.1515 57.1673 49.5728 53.9503C52.3905 51.9002 54.7099 49.3546 56.445 46.4574L55.6114 46.3268V46.3313Z"
        fill="white"
      />
      <Path
        d="M13.0511 21.167C14.7499 18.2293 17.0603 15.6431 19.8961 13.584C24.1816 10.4661 29.2417 8.83509 34.4513 8.83509C35.7288 8.83509 37.0153 8.93422 38.3019 9.13246C41.8127 9.67314 45.0879 10.9347 47.9827 12.8045L48.4085 12.1512C45.4277 10.2228 42.0437 8.9252 38.4242 8.362C27.6109 6.69042 17.3049 12.0656 12.2312 21.0408L13.0511 21.167Z"
        fill="white"
      />
      <Path
        d="M42.2658 25.6823L53.9942 7.72288C54.1165 7.53815 54.0621 7.29034 53.8764 7.16869C53.6907 7.04703 53.4415 7.1011 53.3192 7.28583L41.396 25.5471L42.2703 25.6823H42.2658Z"
        fill="white"
      />
      <Path
        d="M10.1882 33.7747C10.2516 33.3828 10.007 33.1395 9.55851 33.0674L8.64344 32.9232L8.4577 34.1172L9.38637 34.2614C9.83485 34.3289 10.1293 34.1352 10.1837 33.7838V33.7702L10.1882 33.7747ZM9.73972 36.5097L9.05567 35.0408L8.33539 34.9282L8.12701 36.2573L7.2074 36.1132L7.86426 31.959L9.77596 32.2564C10.759 32.4095 11.2709 33.0178 11.135 33.8739V33.8874C11.0263 34.5587 10.5959 34.9237 10.0342 35.0363L10.8224 36.6809L9.74878 36.5142L9.73972 36.5097Z"
        fill="white"
      />
      <Path
        d="M13.1282 37.037L13.785 32.8828L16.938 33.3739L16.8066 34.1849L14.5687 33.838L14.4374 34.6806L16.408 34.9869L16.2766 35.8025L14.3105 35.4916L14.1701 36.3657L16.4397 36.7216L16.3128 37.5326L13.1282 37.037Z"
        fill="white"
      />
      <Path
        d="M19.4408 33.7625L18.7855 37.9199L19.703 38.063L20.3583 33.9055L19.4408 33.7625Z"
        fill="white"
      />
      <Path
        d="M25.6222 38.9817L26.048 36.2693L24.5938 37.8598H24.5712L23.6833 35.9179L23.2574 38.6167L22.356 38.4725L23.0128 34.3184L24.0049 34.4716L24.8249 36.4L26.1975 34.814L27.1896 34.9717L26.5372 39.1259L25.6222 38.9817Z"
        fill="white"
      />
      <Path
        d="M31.4796 36.7341L30.714 37.9957L31.8239 38.1669L31.4796 36.7341ZM32.2587 40.0187L32.0232 39.0275L30.2564 38.7526L29.7264 39.6267L28.7887 39.4825L31.2395 35.5762L32.0866 35.7068L33.2191 40.1719L32.2587 40.0232V40.0187Z"
        fill="white"
      />
      <Path
        d="M37.2057 40.861C35.9055 40.6583 35.1535 39.6085 35.3438 38.3829V38.3694C35.5295 37.1889 36.6077 36.3644 37.8761 36.5627C38.6281 36.6798 39.0494 36.9547 39.43 37.3872L38.7414 37.9909C38.4605 37.6755 38.1978 37.4773 37.7176 37.4007C37.0471 37.2971 36.4265 37.8017 36.3133 38.5091V38.5226C36.1909 39.2841 36.6304 39.9239 37.3688 40.0365C37.704 40.0906 38.0166 40.05 38.2748 39.9239L38.3699 39.3291L37.4458 39.1849L37.5726 38.3964L39.3847 38.6803L39.0993 40.4871C38.61 40.7799 37.9758 40.9872 37.2102 40.8655"
        fill="white"
      />
      <Path
        d="M42.1938 37.3054L41.5385 41.4629L42.4559 41.6059L43.1112 37.4485L42.1938 37.3054Z"
        fill="white"
      />
      <Path
        d="M48.0461 42.479L46.4379 39.5233L46.0211 42.1636L45.1151 42.0239L45.7674 37.8652L46.6146 38.0004L48.1729 40.8615L48.5761 38.3023L49.4821 38.4465L48.8253 42.6006L48.0461 42.479Z"
        fill="white"
      />
      <Path
        d="M51.4392 43.0102L52.0961 38.8516L55.249 39.3427L55.1176 40.1582L52.8798 39.8068L52.7484 40.6538L54.719 40.9602L54.5876 41.7712L52.6216 41.4648L52.4811 42.3389L54.7507 42.6903L54.6239 43.5059L51.4392 43.0102Z"
        fill="white"
      />
      <Path
        d="M60.2683 42.2536C60.386 41.5192 59.9557 40.92 59.2037 40.8028L58.4925 40.6902L58.0983 43.1953L58.8096 43.3079C59.5616 43.4251 60.1505 43.0015 60.2637 42.2626V42.2491L60.2683 42.2536ZM58.6782 44.137L57.0474 43.8847L57.7042 39.7305L59.3351 39.9828C60.6488 40.19 61.4144 41.2263 61.2286 42.3933V42.4068C61.0429 43.5783 59.9919 44.3442 58.6782 44.137Z"
        fill="white"
      />
    </G>
  </Svg>
);

export default React.memo(AramarkMenuItemBoilerPlate);
